import studentsService from '../services/students.service';

async function EditBracelet(data) {
    try {
        await studentsService.EditBraceletStudent(data);
    } catch (error) {
        throw new Error(error);
    }
}

async function GetActiveBracelets(args) {
    try {
        return await studentsService.GetBraceletStudent(false, { student_id: args });
    } catch (error) {
        throw new Error(error);
    }
}

async function DeleteBracelet(data) {
    try {
        await studentsService.DeleteBraceletStudent(false, data);
    } catch (error) {
        throw new Error(error);
    }
}

export { DeleteBracelet, EditBracelet, GetActiveBracelets };
